<template>
  <div>
    <h1>
      <b>Informe general</b>
    </h1>

    <div class="form-group pull-left">
      <button
        @click="generarInforme"
        type="button"
        class="btn btn-success md-elevation-24"
      >
        <i class="fa fa-file"></i> Generar en excel
      </button>
    </div>

    <div>
      <div
        class="form-group pull-right"
        style="padding-right: 10px; padding-left: 10px; text-align: right;"
      >
        <input
          type="text"
          class="search form-control"
          v-model="filter"
          placeholder="Buscar orden"
        />
        <a-pagination
          style="padding-top: 10px"
          @change="onChange"
          :current="page"
          :total="pagination.totalPage"
        />
      </div>

      <span class="counter pull-right"></span>
      <div class="row">
        <div class="col-md-3 pull-left">
          <div class="form-group">
            <label>Desde</label>
            <datetime
              :auto="true"
              value-zone="America/Bogota"
              input-id="desde"
              :max-datetime="maxDataTime"
              title="Fecha inicio filtro"
              input-class="form-control"
              v-model="desde"
            ></datetime>
          </div>
        </div>
        <div
          class="col-md-3 pull-left"
          style="display: inline-flex;
    align-items: center;"
        >
          <div class="form-group">
            <label>Hasta</label>
            <datetime
              :auto="true"
              value-zone="America/Bogota"
              input-id="hasta"
              :max-datetime="maxDataTime"
              title="Fecha fin filtro"
              input-class="form-control"
              v-model="hasta"
            ></datetime>
          </div>
          <div style="padding-left: 5px;">
            <a-button
              shape="circle"
              :loading="procesando"
              type="danger"
              icon="close"
              @click="limpiarFiltros"
            ></a-button>
          </div>
        </div>

        <div style="padding-left: 15%;">
          <div class="form-group">
            <md-checkbox
              @change="
                v => {
                  if (v) {
                    this.pagination.entregado = null;
                    this.getOrdenes();
                  }
                }
              "
              v-model="pagination.terminado"
              class="md-primary"
              >Fecha_terminado</md-checkbox
            >
            <md-checkbox
              @change="
                v => {
                  if (v) {
                    this.pagination.terminado = null;
                    this.getOrdenes();
                  }
                }
              "
              v-model="pagination.entregado"
              class="md-primary"
              >Fecha_entrega</md-checkbox
            >
          </div>
        </div>
        <div id="table" class="col-xs-12 table-responsive">
          <Load v-if="procesando" text="Buscando información"></Load>
          <md-table
            md-elevation-24
            v-else
            v-model="row"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            md-card
          >
            <md-table-empty-state
              md-label="No se encontrarón datos"
            ></md-table-empty-state>
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell
                md-label="Nro OS"
                md-sort-by="ordenId"
                md-numeric
                >{{ item.ordenId }}</md-table-cell
              >
              <md-table-cell
                md-label="Fecha_creación"
                md-sort-by="created_at"
                >{{ `${item.created_at}` }}</md-table-cell
              >
              <md-table-cell
                md-label="Nombre del cliente"
                md-sort-by="clienteNombre"
                >{{
                  `${item.clienteNombre} ${item.clienteApellidos}`
                }}</md-table-cell
              >
              <md-table-cell
                md-label="Quién recibe"
                md-sort-by="usuario_recibe"
                >{{
                  `${item.usuario_recibe.split('-')[1]}`
                }}</md-table-cell
              >
              <md-table-cell
                md-label="Técnico Asignado"
                md-sort-by="tecnicoNombre"
                >{{
                  `${item.tecnicoNombre} ${item.tecnicoApellidos}`
                }}</md-table-cell
              >
              <md-table-cell
                md-label="Servicio"
                md-sort-by="servicio"
              >
                {{
                  `${
                    row.servicio === 'Análisis' ||
                    item.servicio === 'Analisis'
                      ? item.servicio_realizado != null
                        ? item.servicio_realizado.toUpperCase()
                        : 'ANÁLISIS EN PROCESO'
                      : item.servicio.toUpperCase()
                  }`
                }}
              </md-table-cell>
              <md-table-cell md-label="Marca" md-sort-by="marca">{{
                item.marca
              }}</md-table-cell>
              <md-table-cell md-label="Estado" md-sort-by="estado">
                {{ `${JSON.parse(item.estado).estado}` }}
                <i
                  v-if="
                    JSON.parse(item.estado).estado === 'Pendiente'
                  "
                  class="fa fa-info-circle"
                >
                  <md-tooltip
                    v-if="
                      JSON.parse(item.estado).pendiente.autorizacion
                    "
                    md-direction="right"
                    >Autorización</md-tooltip
                  >
                  <md-tooltip
                    v-if="JSON.parse(item.estado).pendiente.repuesto"
                    md-direction="right"
                    >Repuesto</md-tooltip
                  >
                  <md-tooltip
                    v-if="
                      JSON.parse(item.estado).pendiente.cotizacion
                    "
                    md-direction="right"
                    >Cotización</md-tooltip
                  >
                </i>
              </md-table-cell>
              <md-table-cell
                md-label="Valor servicio"
                md-sort-by="precio"
                >{{ item.precio | currency }}</md-table-cell
              >
              <md-table-cell
                md-label="Fecha Finalización"
                md-sort-by="fecha_terminado"
                >{{
                  item.fecha_terminado
                    ? item.fecha_terminado
                    : 'SIN TERMINAR'
                }}</md-table-cell
              >
              <md-table-cell
                md-label="Fecha Entrega"
                md-sort-by="fecha_entrega"
                >{{
                  item.fecha_entrega
                    ? item.fecha_entrega
                    : 'SIN ENTREGAR'
                }}</md-table-cell
              >
            </md-table-row>
          </md-table>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12 form-inline">
          <!-- <datatable-pager v-model="page" type="abbreviated" :per-page="per_page"></datatable-pager> -->
          <!-- <a-pagination  @change="onChange" :current="page" :total="pagination.totalPage" /> -->
        </div>
      </div>
    </div>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :on-cancel="onCancel"
      loader="dots"
      color="#164880"
      :is-full-page="true"
    ></loading>
  </div>
</template>
<script>
import ServiceApi from '../../ServiceApi';
import Loading from 'vue-loading-overlay';
import Load from '../Helpers/Loading';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import { mapState } from 'vuex';
import { Datetime } from 'vue-datetime';
import Moment from 'moment';
export default {
  name: 'informes',
  components: {
    Loading,
    Load,
    datetime: Datetime,
  },
  computed: mapState(['usuario', 'rol', 'usuarioId']),
  data() {
    return {
      filter: '',
      currentSort: 'ordenId',
      currentSortOrder: 'desc',
      loading: true,
      procesando: false,
      pagination: {
        page: 1,
        total: 0,
        totalPage: 10,
        search: '',
        terminado: null,
        entregado: null,
      },
      desde: null,
      hasta: null,
      range: {
        desde: null,
        hasta: null,
      },
      page: 1,
      row: [],
      per_page: 100,
      maxDataTime: '',
    };
  },
  watch: {
    filter() {
      this.pagination.search = this.filter;
      this.procesando = true;
      this.getOrdenes();
    },
    desde() {
      this.range.desde = Moment(this.desde).format(
        'YYYY-MM-DD 00:00:00'
      );
    },
    hasta() {
      this.range.hasta = Moment(this.hasta).format(
        'YYYY-MM-DD 23:59:59'
      );
      if (this.range.hasta != null) {
        this.loading = true;
        this.getOrdenes();
      }
    },
  },
  created() {
    this.maxDataTime = Moment().format();
    this.getOrdenes();
  },
  mounted() {},
  methods: {
    limpiarFiltros() {
      this.range = {
        desde: null,
        hasta: null,
      };
      this.pagination.terminado = null;
      this.pagination.entregado = null;
      this.loading = true;
      this.getOrdenes();
      this.desde = null;
      this.hasta = null;
    },
    onCancel() {},
    onChange(page) {
      this.pagination.page = page;
      this.page = page;
      this.getOrdenes();
    },
    getOrdenes() {
      // this.loading = true
      let data = {
        filter: this.pagination,
        orden: {
          entidad: this.currentSort,
          tipo: this.currentSortOrder,
        },
        range: this.range,
      };
      ServiceApi.post(`/ordenes/list`, data)
        .then(response => {
          // console.log('RESPUESTA:::', response)
          let data = response.data.data;
          this.row = data.ordenes.map((item, key) => {
            item.clienteFullName = `${item.clienteNombre} ${
              item.clienteApellidos
            }`;
            item.tecnicoFullName = `${item.tecnicoNombre} ${
              item.tecnicoApellidos
            }`;
            return item;
          });
          let pagination = data.paginacion;
          this.pagination.totalPage = pagination.lastPage * 10;
          this.pagination.total = pagination.total;
          // if(!data.ordenes.length)this.$noty.warning('No se encontraron ordenes de servicio creadas')
          this.loading = false;
          this.procesando = false;
        })
        .catch(err => {
          // this.$noty.error('Ocurrio un error al consultar las tarjetas')
          this.loading = false;
          this.procesando = false;
          this.$router.push('/');
        });
    },
    showModal(ordenId) {
      Swal.fire({
        type: 'success',
        title: `Se acaba de generar la entrega de la orden # ${ordenId}`,
        showConfirmButton: false,
        timer: 3000,
      });
    },
    entregarOrden(ordenId) {
      this.loading = true;
      let data = {
        ordenId,
        entregado: true,
        fecha: Moment().format('YYYY/MM/DD h:mm:ss'),
      };
      ServiceApi.post('/orden/entregar', data)
        .then(response => {
          this.getOrdenes();
          this.loading = false;
          this.showModal(ordenId);
        })
        .catch(err => {
          this.$noty.error(
            'Ocurrio un error al consultar las tarjetas'
          );
          this.loading = false;
          this.$router.push('/');
        });
    },
    customSort(value) {
      if (
        this.currentSort === 'ordenId' ||
        this.currentSort === 'precio' ||
        this.currentSort === 'terminado' ||
        this.currentSort === 'entregado'
      ) {
        this.getOrdenes();
      } else {
        return value.sort((a, b) => {
          const sortBy = this.currentSort;
          if (this.currentSortOrder === 'desc') {
            return a[sortBy].localeCompare(b[sortBy]);
          }

          return b[sortBy].localeCompare(a[sortBy]);
        });
      }
    },
    getFiltroFecha() {
      console.log('PAGINATION:::::', this.pagination);
      if (this.pagination.entregado) {
        return 'fecha_entrega';
      }
      if (this.pagination.terminado) {
        return 'fecha_terminado';
      }
      return null;
    },
    async generarInforme() {
      const filter = this.getFiltroFecha();
      // console.log('FILTER:::::', filter);
      // window.open(`http://app.tarjetasecotronica.com/informe`);
      // const url = `https://servitronik.com.co/informe/${`${
      const url = `https://app.solucasa.com.co/informe/${`${
        // const url = `http://localhost:3333/informe/${`${
        this.desde ? Moment(this.desde).format('YYYY-MM-DD') : null
      }`}/${
        this.hasta ? Moment(this.hasta).format('YYYY-MM-DD') : null
      }/${filter}/${this.tipo_pago}`;
      window.open(url);
    },
  },
};
</script>
